export default {
  langType: 'zh_cn',
  langName: '简体中文',
  productName: '先知命局',
  slogan: '先知命局洞悉人生，先人一步知命用命',
  more: '了解更多',
  care: '关注我们',
  contact: '联系我们',
  copy: '复制成功',
  agreement: '服务协议',
  policy: '隐私政策',
  company: '公司：SEER ONNET PTE. LTD.',
  // 老师名字
  林鹤: '林鶴',
  易烊枫燧: '易烊枫燧',
  法銘道長: '法銘道長',
  赵振鸿: '赵振鸿',
  道元: '道元',
  // 老师标签
  实战派: '实战派',
  传道者: '传道者',
  执法者: '执法者',
  表演者: '表演者',
  联结者: '联结者',
  // 老师描述
  日常命运的解构者: '日常命运的解构者',
  心性修行的引领者: '心性修行的引领者',
  幽冥因果的沟通者: '幽冥因果的沟通者',
  现实成就的缔造者: '现实成就的缔造者',
  古今智慧的翻译师: '古今智慧的翻译师',
  // 技能标签
  四柱八字: '四柱八字',
  紫微斗数: '紫微斗数',
  掌面相: '掌面相',
  玄空风水: '玄空风水',
  环境风水: '环境风水',
  梅花易数: '梅花易数',
  手相面相: '手相面相',
  天眼通: '天眼通',
  六壬术法: '六壬术法',
  灵修导师: '灵修导师',
  奇门遁甲: '奇门遁甲',
  数字能量学: '数字能量学',
  奇门术法: '奇门术法',
  小六壬: '小六壬',
  高端风水布局: '高端风水布局',
  八字命理: '八字命理',
  风水堪舆: '风水堪舆',
  铁板神数: '铁板神数',
  // 学院介绍
  academyIntro:
    '欢迎来到《超能力学院》，一所跨越现实与未知的玄学竞技学院。《超能力学院》是一个由枫燧、法铭、道元、振鸿四位玄学导师联合发起，汇聚世界各地多位名师，涵盖八字、风水、神通、萨满、魔法等东西方学术，旨在为用户提供丰富、专业且值得信赖的命运指导服务的机构。',
  // 学院特色
  academyFeature:
    '他们是超能力领域的顶尖强者，更是因材施教的启蒙大师能解锁你的潜力上限，能定制专属修炼路径，能带你突破能力瓶颈！\n\n学院的亮点从不是噱头，而是每位导师用实力兑现的 "超能力成长承诺"！',
  recordUserComment:
    '本人于 2024 年 12 月 31 日偿还半数受生债后，近 10 个月以来生活确有小幅改善。例如，我们成功从香港迁居澳洲，顺利觅得一处称心居所，日常心情也愈发舒畅 —— 终于得以远离香港家中的纷扰是非。此外，我十年前曾在澳洲另一地区购置了一套房产，因地段欠佳，挂牌多年都未能脱手。好在数月前有买家主动出价，尽管最终略有亏损，但总算是成功售出。如今，我衷心期盼在香港及海外的其他物业，都能顺利找到买家。🙏🏼😃',
  // 数据统计
  recordUserCount: '20',
  recordUserCountHighlight: '万+',
  recordUserCountDesc: '真实用户',
  recordAccuracy: '98.20%',
  recordAccuracyHighlight: '准确率',
  recordAccuracyDesc: '来自我们的客户评价',
  recordScore: '4.8/5',
  recordScoreHighlight: '星',
  recordScoreDesc: '好评平均分',
  recordExpertCount: '100',
  recordExpertCountHighlight: '+',
  recordExpertCountDesc: '专业老师团队',
  // 视频相关
  '《超能力学院》第一季': '《超能力学院》第一季',
  videoTitle1:
    '导师宣传片：《超能力学院》导师法铭强势来袭！听懂亡者的未尽之言，一剑斩开玄学迷雾！节目6月14日首播！',
  videoTitle2:
    '导师宣传片：《超能力学院》导师道元高能登场！ 以玄学洞悉趋势、掌局未来！节目6月14日首播！',
  videoTitle3:
    '超能力学院第一集：惊悚海选日！Ives生吞香烛吓翻全场！女巫海诺追星成功，但被竞争对手下黑手？祖师爷显灵相助，麟龙当场跪哭！',
  videoTitle4: '超能力学院·第四集：海选日全员被下咒，幕后黑手竟然是他！15进9，战队成立，正式开学！',
  videoSeasonIntro:
    '欢迎来到《超能力学院》\n一所跨越现实与未知的玄学竞技学院。\n15位术法新星、3位玄学导师，\n在真实竞技中挑战命运、觉醒潜能。\n这里没有剧本，只有考验。\n他们要面对的不只是对手，\n还有自己的内心、未知的恐惧、隐藏的力量。\n每一次试炼，都是命运的拐点。\n每一场对决，都是术法与信念的较量。\n《超能力学院》———开启属于你的觉醒之门。',
  followYouTube: '关注《超能力学院》YouTube',
  // 服务相关
  '看命盘/看八字': '看命盘/看八字',
  service1Feature1: '正统道教背景,正壹派弟子',
  service1Feature2: '20年实战经验，已服务10000+学员',
  service1Feature3: '线上1对1沟通，30分钟出初步解析',
  service1Description:
    '精准八字测算服务，透过八字命盘、个人资料分析，提供量身定制的命理咨询，以改善个人运势和命运。服务涵盖姻缘、事业、财运等方面。',
  法事祈福: '法事祈福',
  service2Feature1: '正壹派正规法事流程，附法事疏文存根',
  service2Feature2: '法事前提供需求沟通，事后给护持建议',
  service2Feature3: '支持香港现场参与/线上视频回看',
  service2Description:
    '正统道教法事祈福：针对冤亲债主化解、家宅净宅除煞、事业财运增益、健康平安祈福等需求，由高功道长主持正规法事，护佑运势顺畅。',
  起名改名: '起名改名',
  service3Feature1: '八字五行精准适配，拒绝随机选字',
  service3Feature2: '3套命名方案+字义解析，可挑选调整',
  service3Feature3: '公司命名匹配行业属性，助力开局顺利',
  service3Description:
    '开运命名服务：根据玄学五行、八字喜忌与风水纳福原理，提供婴儿、个人、公司机构的量身定制取名/改名方案，助运势提升、避凶趋吉。',
  风水布局: '风水布局',
  service4Feature1: '上门勘测+现场标煞，拒绝线上盲判',
  service4Feature2: '提供家具摆放、挂饰选用等可落地方案',
  service4Feature3: '商铺布局适配客流动线，助推业绩提升',
  service4Description:
    '空间能量重置：依九宫飞星与命理五行，上门勘测商铺、办公室、家居空间，精准调和藏风聚气格局，化解煞位、旺财旺人丁。',
  课程讲座: '课程讲座',
  service5Feature1: '理论+案例分析，不讲“空泛理论”',
  service5Feature2: '课后1对1答疑+学习群，避免学完就忘',
  service5Feature3: '课程可反复观看，持续学习',
  service5Description:
    '玄学实战课程学习：针对八字入门、风水基础、择日要诀等内容，由20年经验导师线上直播授课+线下实操指导，助学员掌握实用玄学技能。',
  择日: '择日',
  service6Feature1: '依个人/企业八字定制，拒绝通用黄历',
  service6Feature2: '3套吉日建议+吉时说明，可自由挑选',
  service6Feature3: '附简易开运注意事项+行事宜忌说明',
  service6Description:
    '依据天干地支、阴阳五行、紫白飞星等原理，为结婚开张、入伙动土、开光祭祀、签约出行等重大事宜甄选良辰吉时，助你趋吉避凶、事事顺遂。',
  加whatsapp获取免费服务资格: '加WhatsApp获取免费服务资格',
  // 评论相关
  精选好评直出睇完就知几得: '精选好评直出！看完就知道有多靠谱！',
  // 评论1
  comment1Name: 'Amber Wang',
  comment1Text:
    '前几个月有同大师兄喺youtube节目连线，佢有指导我一些小妙招。依家生意好转了好多。想嚟感谢大师兄。',
  // 评论2
  comment2Name: '蘇小姐',
  comment2Text: '山凡师兄 五行手链佩戴了大约两个月没有见面半年的朋友话我面色气息好转 精气神饱满🙏',
  // 评论3
  comment3Name: 'Gnulnam Oh',
  comment3Text:
    '我之前个房都係五鬼位，训入去成日失眠，周身唔舒服，个人身体比较敏感，所以搬去客厅训，真係训得好左，现在跟大师兄学风水先知係什么问题。',
  // 评论4
  comment4Name: 'Kit Choi',
  comment4Text:
    '11月4日当天，心情有一些暴躁，有点火！但5号开始，心情好像轻松了，虽然在工作上一样受到不公平的对待，但心态好像平静了，呼吸一下就没事了！感觉人好像轻松了一点！其他的，还在发掘中！',
  // 评论5
  comment5Name: 'Vienie Bebelove',
  comment5Text: '都要多谢你一声，自送走童人，我觉得係好咗。',
  // 评论6
  comment6Name: '蔡小姐',
  comment6Text:
    '唔知有冇凝住，我带咗心情好咗，少咗负面嘢諗，做事顺利咗，还有之前经常带住个泰国佛牌，讲负面嘢乱发脾气，经常扰乱我嘅同事，10月初突然话有胆石要去医院割胆囊，足足一个月冇见，我就返咗一个月工冇休息，但係个人都好精神',
  // 评论7
  comment7Name: 'Sean Lee',
  comment7Text: '感谢感谢，做完后昨天我感觉有些神奇，个人真係好似轻松咗，心情都好咗。',
  // 评论8
  comment8Name: '張先生',
  comment8Text:
    '我爱易烊枫燧老师，专业，亲切，帮我解决了人生迷茫解答准确率很高，很耐心，没有知识优越感，强烈推荐。',
  // 表单相关
  立即获得免费服务资格: '立即获得免费服务资格',
  告诉我们您的需求专业老师会在1个工作日为您服务: '告诉我们您的需求，专业老师会在1个工作日为您服务',
  您的姓名: '您的姓名',
  请填写您的姓名: '请填写您的姓名',
  您的WhatsApp: '您的WhatsApp',
  请填写您的WhatsApp: '请填写您的WhatsApp',
  您的电话电邮: '您的电话/电邮',
  请填写您的电话或电邮: '请填写您的电话或电邮',
  选择您想咨询的老师: '选择您想咨询的老师',
  您想咨询的问题: '您想咨询的问题',
  请简单描述您想咨询的问题: '请简单描述您想咨询的问题',
  请选择老师: '请选择老师',
  立即提交: '立即提交',
  提交成功: '提交成功',
  提交失败: '提交失败',
  我们会尽快与您联系: '我们会尽快与您联系',
  表单提交成功提示: '您的问题已提交成功，我们将在一个工作日内与您联系，感谢您的耐心等待。',
  表单提交失败提示: '提交失败，请刷新页面后重试。',
  // 老师选项
  teacher1Name: '易烊枫燧',
  teacher1Skills: '四柱八字命理、环境风水布局、梅花易数、手相面相',
  teacher2Name: '赵振鸿',
  teacher2Skills: '八字命理、紫微斗数、掌面相、玄空风水',
  teacher3Name: '法銘道長',
  teacher3Skills: '天眼通、摸骨测字、祝由术',
  teacher4Name: '道元',
  teacher4Skills: '数字能量学、奇门术法、小六壬、高端风水布局',
  // 底部相关
  联系我们: '联系我们',
  地址: '香港铜锣湾告士打道262号中粮大厦20楼2003室',
  邮箱: 'chaonenglixueyuan@gmail.com',
  电话: '85284833986（超能力學院-山寺師兄）',
  营业时间: '工作日开放，10:00~19:00',
  品牌链接: '品牌链接',
  加入先知命局: '加入先知命局',
  免费领取每日运势及会员福利: '免费领取每日运势及会员福利',
  LINE给你: 'LINE給你',
  FollowUs: 'Follow Us',
  // 合作媒体相关
  合作媒体: '合作媒体',
  '电视台/广播电台': '电视台/广播电台',
  线上串流平台: '线上串流平台',
  新媒体全渠道曝光: '新媒体全渠道曝光',
  '报道+网媒': '报道+网媒',
  '名师匠心打造+权威媒体精选': '名师匠心打造+权威媒体精选',
  超多服务选择全都帮你拆解难题解决烦恼: '超多服务选择，全都帮你拆解难题、解决烦恼！',
  挑选适合自己的服务白版说明:
    '挑选适合自己的服务，你所有想了解的问题，都会得到专业解答!你可以尽情倾诉人生前路与未来规划，深入交流爱情生活、职业选择，以及生活中的各类大小事务，放心畅聊，毫无拘束!',
  超十万次真实案例全实录: '超十万次真实案例全实录',
  版权信息: '© 2025 超能力学院 ｜All Rights Reserved.',
  名师匠心打造: '名师匠心打造',
  权威媒体精选: '权威媒体精选',
  超能力学院: '超能力学院',
  金牌导师天团: '金牌导师天团',
  超多服务选择: '超多服务选择',
  真实的口碑安心的服务: '真实的口碑，安心的服务',
  精选好评直出: '精选好评直出',
  睇完就知幾得: '看完就知道有多靠谱！',
  TaoistFengsui: 'TaoistFengsui',
  '赵振鸿Master Chiu': '赵振鸿Master Chiu',
  法铭灵距离: '法铭灵距离',
  'Mr.DaoYuan': 'Mr.DaoYuan',
  立即下载: '立即下载',
};
